export default function randomArray(items, number) {
  const srcArray = Array.from(items);
  const retArray = [];

  for (let i = 0, len = Math.min(number, items.length); i < len; i++) {
    const index = Math.floor(Math.random() * srcArray.length);
    retArray.push(srcArray.splice(index, 1)[0]);
  }

  return retArray;
}
